import { get } from 'svelte/store';

import { userID, isLogin, omegaParams } from '../store/index';

import {
    buildCreditCardCommonParams,
    getAdvParameters
} from '@/utils/creditCardTrackParams';
import { getParamsUI, GROUP_TYPE_PARAM, UI_TYPES } from '@/utils/group';
import { trackEvent as trackEventFn } from '@/utils/omega';
import url from '@/utils/url';

type TrackAttrs = {
    [key: string]:
        | string
        | boolean
        | number
        | object
        | []
        | undefined
        | null;
};

export const refreshOmegaParams = (ext?: Record<string, unknown>) => {
    try {
        const pubPage =
            (ext?.pub_page as string) ||
            (window.location.pathname.includes('card-end')
                ? 'card-end'
                : 'card-regular');
        const commonParams = buildCreditCardCommonParams({
            pubPage,
            uid: get(userID),
            pub_uid: get(userID),
            ext: {
                ...getAdvParameters(),
                ui_type:
                    (ext?.ui_type as string) ||
                    getParamsUI(
                        GROUP_TYPE_PARAM,
                        UI_TYPES,
                        pubPage === 'card-end' ? 'B' : 'A'
                    ),
                page_source: 'creditcard',
                ...ext
            }
        });

        omegaParams.set({
            ...commonParams,
            is_login: get(isLogin) ? 1 : 0
        });

        return {
            ...commonParams,
            is_login: get(isLogin) ? 1 : 0
        };
    } catch (error) {
        console.error(error);
    }
};

export const prepareOmegaParams = () => refreshOmegaParams();

export const trackEvent = (eventId: string, attrs?: TrackAttrs) => {
    try {
        const pubPage = window.location.pathname.includes('card-end')
            ? 'card-end'
            : 'card-regular';
        const publicParams = {
            ...buildCreditCardCommonParams({
                pubPage,
                uid: get(userID),
                pub_uid: get(userID),
                ext: {
                    ...getAdvParameters(),
                    ui_type: getParamsUI(
                        GROUP_TYPE_PARAM,
                        UI_TYPES,
                        pubPage === 'card-end' ? 'B' : 'A'
                    ),
                    page_source: 'creditcard'
                }
            }),
            group_type: url.get('group_type') || 'group_a',
            from_traffic_cnn: url.get('from_traffic_cnn') || '',
            pub_from_quickbolt: url.get('pub_from_quickbolt') || '',
            relation_id: url.get('relation_id') || '',
            is_sign: get(isLogin) ? 1 : 0,
            is_login: get(isLogin) ? 1 : 0,
            ...attrs
        };

        omegaParams.set(publicParams);

        return trackEventFn(eventId, publicParams);
    } catch (error) {
        console.error(error);
    }
};
